export default "__VITE_ASSET__TGAhH70z__";